import { render, staticRenderFns } from "./coudiere.vue?vue&type=template&id=0612d842"
import script from "./coudiere.vue?vue&type=script&lang=js"
export * from "./coudiere.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports